import { render } from "./bestsellerPage.vue?vue&type=template&id=7e087d00"
import script from "./bestsellerPage.vue?vue&type=script&lang=js"
export * from "./bestsellerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__